import { Button, Flex, Heading } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const ErrorSection = ({ text = '' }) => {
  const navigate = useNavigate()
  return (
    <Flex w="100%" h="calc(80vh)" alignItems="center" justifyContent="center" direction="column" gap="5">
      <Heading>Error ! {text}</Heading>
      <Button colorScheme="teal" onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </Flex>
  )
}

export default ErrorSection
